export default "/images/04587f27f2e691ad144cdc6ec9c7de11.avif";